import EmailVerifiedPage from "./EmailVerifiedPage";

export default EmailVerifiedPage;